import GuestReviewCarousel from "./GuestReviewCarousel";

export default function GuestExperience() {
  return (
    <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(40px,5vw,64px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 8, marginTop: 0 }}>
            Guest experience
          </p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(22px,3vw,32px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#112215", margin: "0 auto 8px", maxWidth: 620 }}>
            What guests say about their stays
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: "#5C7268", lineHeight: 1.5, maxWidth: 480, margin: "0 auto" }}>
            4.76 average across 1,000+ Airbnb reviews.
          </p>
        </div>

        <GuestReviewCarousel />
      </div>
    </section>
  );
}